import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Coupon_card from "../../Components/Coupon_card/coupon_card";
import coupon_frame from "../../Assets/Images/icons/coupon_frame.png"
import axiosInstance from "../../Services/axios";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import NodeaxiosInstance from "../../Services/nodeaxios";

export default function My_coupon_list() {
    const navigate = useNavigate();
    const valueParam = useParams();
    const [coupon_list, setCoupon_list] = useState([])
    const location = useLocation();
    const { cart_id, fromPage } = location.state || {}
    const [coupon, setCoupon] = useState()
    const [cartId, setCartId] = useState("");
    const [pageLoaded, setPageLoaded] = useState(false)
    const [couponRawdata, setCouponRawdata] = useState([])
    const [selectedTab, setSelecteTab] = useState(1)

    useEffect(() => {
        vendor_coupons_list()
    }, [])
    
    const vendor_coupons_list = () => {
        try { 
            NodeaxiosInstance.post("/profile/my-coupons-list")
                .then((res) => {
                    const data = res.data;
                    const myCouponsData = data.my_coupon_list;
                    setCoupon_list(myCouponsData)
                    setCouponRawdata(myCouponsData)
                })
                .catch((err) => {
                    if (err.response?.status == 400 || err.response?.status == 500) {
                        toast(err.response.data.message, { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
                    }
                })
                .finally(() => {
                    setPageLoaded(true)
                });
        } catch (error) {
            showToast(" please content pingle are Try again later", { position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1", });
        }
    };


    useEffect(() => {
        if (couponRawdata && couponRawdata.length > 0) {
            const myCoupons = [];
            couponRawdata.map((coupon) => {
                if (selectedTab == 3 && coupon?.redeemed_status == 1) {
                    myCoupons.push(coupon);
                } else if (selectedTab == 4 && (coupon?.expired_status == 1 && coupon?.redeemed_status == 0)) {
                    myCoupons.push(coupon);
                } else if (selectedTab == 2 && (coupon?.redeemed_status == 0 && coupon?.expired_status == 0)) {
                    myCoupons.push(coupon);
                } else if (selectedTab == 1) {
                    myCoupons.push(coupon);
                }
            })
            setCoupon_list(myCoupons);
        }
    }, [selectedTab])


    return (
        <>
            {
            pageLoaded ?
                <div className=" ">
                    <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  " >
                        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                            <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
                            <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                                My coupons
                            </div>
                        </div>
                    </div>



                    <div className="p-3">
                        <div className="col-10">
                            <div className="d-flex justify-content-between ">
                                <button className={`coupon_nav_btn ${selectedTab == 1 ? "primary-bg text-light ff-poppins-semiBold" : ""} `} onClick={() => setSelecteTab(1)} >All</button>
                                <button className={`coupon_nav_btn ${selectedTab == 2 ? "primary-bg text-light ff-poppins-semiBold" : ""} `} onClick={() => setSelecteTab(2)}>Active</button>
                                <button className={`coupon_nav_btn ${selectedTab == 3 ? "primary-bg text-light ff-poppins-semiBold" : ""} `} onClick={() => setSelecteTab(3)}>Redeemed</button>
                                <button className={`coupon_nav_btn ${selectedTab == 4 ? "primary-bg text-light ff-poppins-semiBold" : ""} `} onClick={() => setSelecteTab(4)}>Expired</button>
                            </div>
                        </div>
                        {/* Coupon List */}
                        <div className="scroller-style-y mt-2" style={{ paddingBottom: "40%" }}>

                            {
                            coupon_list?.length > 0 ? (
                                coupon_list?.map((item, index) => (
                                    <div key={index} className="mt-2 mb-2">
                                        <div className=" p-1 rounded-4 coupon_card d-flex" >
                                            <img src={coupon_frame} className="coupon_frame" />
                                            <div className="col-10 ms-1">
                                                <div className="d-flex justify-content-between mt-2">
                                                    <div>
                                                        <h5 className="p-0 m-0 fs-15 ff-poppins-semiBold">{item.coupons_name} </h5>
                                                        <h6 className="p-0 m-0 fs-14 ff-poppins-semiBold primary-text">
                                                            {item.discount} {item.discount_type == 1 ? <FaIndianRupeeSign className="me-1 fs-12" /> : "%"} Discount
                                                        </h6>
                                                    </div>

                                                    <div className={`coupon_status_lable rounded-pill ${item.redeemed_status==1 ? "applied_lable" :item.expired_status==1 ? "expired_lable":"active_lable" } `}  >
                                                         {item.redeemed_status==1 ? "Redeemed" :item.expired_status==1 ? "Expired":"Active" }
                                                    </div>
                                                    {/* {item.applied_status == 1 ? (
                                                        <div className="ff-poppins-semiBold fs-14 primary-text mt-2" onClick={() => { remove_coupon(); setCoupon(item); }}>
                                                            Remove
                                                        </div>
                                                    ) : (
                                                        <button className="apply_btn ff-poppins-semiBold fs-12 mt-2" onClick={() => { apply_coupon(); setCoupon(item); }}>
                                                            Apply
                                                        </button>
                                                    )} */}
                                                </div>
                                                <div className="border_Bootam_Line mt-2"></div>
                                                <div>
                                                    <p className="fs-13 ff-poppins-regular primary-text p-0 m-0 mt-2 ">Required purchase value to redeem - {item.min_pur_amount}</p>
                                                    <p className="fs-10 ff-poppins-regular  m-0 p-0 mt-2">
                                                        {item.coupons_description.length > 100 ? `${item.coupons_description.slice(0, 80)}...` : item.coupons_description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
                                ))
                            ) : (
                                <p className="fs-14 ff-poppins-medium text-center mt-5">No coupons available</p>
                            )}
                        </div>
                    </div>

                </div >
                :
                <div className=" ReactLoading">
                    <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} />     
                </div>
            }
        </>
    )
}